import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import linkedin from "../../assets/linkedin.png"
// Replace with your real team assets
import team_1 from "../../assets/images/team_1.png";
import team_2 from "../../assets/images/team_2.png";
import team_3 from "../../assets/images/team_3.png";
import team_4 from "../../assets/images/team_4.png";
import team_5 from "../../assets/images/team_7.png";
import team_6 from "../../assets/images/team_8.png";
import team_7 from "../../assets/images/team_5.png";
import team_8 from "../../assets/images/team_9.png";
import team_9 from "../../assets/images/team_6.png";
const TEAM_MEMBERS = [
  {
    name: "Suneel Sundaraneedi",
    role: "Founder & CEO",
    image: team_1,
    glowColor: "#62d4f7",
    offset: false,
    size: "h-64 w-64 ",
    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
    ],
  },
  {
    name: "Kishore Yasarapu",
    role: "Head - Corporate Strategy",
    image: team_2,
    glowColor: "#3579be",
    offset: true,
size: "h-64 w-64",
    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
  
    ],
  },
  {
    name: "Balu TV",
    role: "SVP - Customer Success",
    image: team_3,
    glowColor: "#5dc9f0",
    offset: false,
size: "h-64 w-64",    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
    
    ],
  },
  {
    name: "NSV Prasad",
    role: "Head - Finance",
    image: team_4,
    glowColor: "#62d4f7",
    offset: true,
size: "h-64 w-64",    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
    
    ],
  },
];
const CORE_MEMBERS = [
  {
    name: "Siva Puvvada",
   role: "Practice Director – BPM and AI",
    image: team_5,
    glowColor: "#62d4f7",
    offset: false,
size: "h-64 w-64 2xl:w-60 2xl:h-60",    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
    ],
  },
  {
     name: "Krishna Chaitanya",
    role: "Principal Architect-Pega",
    image: team_6,
    glowColor: "#3579be",
    offset: true,
size: "h-64 w-64 2xl:w-60 2xl:h-60",    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
  
    ],
  },
  {
     name: "Muralibabu M",
    role: "Principal Architect- Camunda",
    image: team_7,
    glowColor: "#5dc9f0",
    offset: false,
size: "h-64 w-64 2xl:w-60 2xl:h-60",    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
    
    ],
  },
  {
       name: "Chandrasekhar Kapu",
    role: "Service Delivery Manager",
    image: team_8,
    glowColor: "#62d4f7",
    offset: true,
size: "h-64 w-64 2xl:w-60 2xl:h-60",    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
    
    ],
  },
   {
     name: "Deepthi Dasyam",
    role: "Talent Acquisition Manager",
    image: team_9,
    glowColor: "#5dc9f0",
    offset: false,
size: "h-64 w-64 2xl:w-60 2xl:h-60",    socials: [
      { icon: linkedin, href: "https://linkedin.com", label: "LinkedIn" },
    
    ],
  },
];

function TeamMemberCircle({ member, index }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.12 }}
      className={`flex flex-col items-center ${
        member.offset ? "md:mt-16" : "md:mt-0"
      }`}
    >
      {/* Outer Circular Container */}
      <div className="relative">
        {/* Soft atmospheric backlight colored per persona */}
        <div
          className="pointer-events-none absolute inset-0 rounded-full blur-2xl opacity-30 transition-opacity duration-300"
          style={{ background: member.glowColor }}
        />

        {/* Circular Avatar */}
        <div
          className={`relative rounded-full overflow-hidden border  shadow-[0_12px_35px_rgba(0,0,54,0.08)] bg-slate-100 ${member.size} transition-transform duration-500 hover:scale-102`}
        >
          <img
            src={member.image}
            alt={member.name}
            className="w-full h-full object-cover object-center filter contrast-105"
          />
        </div>

        {/* Expandable Action Hub (+ Icon and Socials) */}
        <div
          className="absolute bottom-1 right-2 sm:bottom-2 sm:right-3 z-30"
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          {/* Animated Social Icon Fan-Out Tray */}
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0, y: 10, scale: 0.8 }}
                animate={{ opacity: 1, y: -8, scale: 1 }}
                exit={{ opacity: 0, y: 6, scale: 0.8 }}
                transition={{ duration: 0.22, ease: "easeOut" }}
                className="absolute bottom-full right-0 flex flex-col items-center gap-2 p-1 rounded-full bg-white/95 backdrop-blur-md border border-slate-200 shadow-xl"
              >
                {member.socials.map((social, i) => {
                  return (
                    <motion.a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 0.8 }}
                      transition={{ delay: i * 0.05 }}
                      aria-label={social.label}
                      className="h-6 w-6 rounded-full   text-[#000036] hover:text-white flex items-center justify-center transition-all duration-200 shadow-xs"
                    >
                      <img src={social.icon} alt="" />
                    </motion.a>
                  );
                })}
              </motion.div>
            )}
          </AnimatePresence>

          {/* Trigger Button with rotation */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            aria-label="View social links"
            className={`h-9 w-9 sm:h-10 sm:w-10 rounded-full border-2 border-white flex items-center justify-center text-white shadow-lg transition-all duration-300 ${
              isOpen
                ? "bg-[#3579be] rotate-45 scale-105"
                : "bg-[#000036] hover:bg-[#3579be] hover:scale-110"
            }`}
          >
            <Plus size={18} strokeWidth={2.5} />
          </button>
        </div>
      </div>

      {/* Typography */}
      <div className="mt-5 text-center max-w-[200px]">
        <h4 className=" text-xl font-bold tracking-tight text-[#000036]">
          {member.name}
        </h4>
        <p className="mt-1 text-base font-sans text-[#000036] font-normal">
          {member.role}
        </p>
      </div>
    </motion.div>
  );
}

export default function AboutTeam2() {
  return (
    <section className="relative w-full py-20 md:py-32 bg-[#fafbfc] text-[#000036] overflow-hidden">
      {/* Subtle brand gradient background illumination */}
      <div
        className="pointer-events-none absolute top-0 left-0 w-full h-full opacity-20 "
        style={{
          background:
            "linear-gradient(135deg, #62d4f7 0%, #5dc9f0 40%, #3579be 60%",
        }}
      />
      <div className="mx-auto 3xl:w-4/5 lg:w-11/12 px-6 lg:px-12 flex justify-center items-center flex-col relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-4 inline-flex items-center gap-2 rounded-full  px-3.5 py-1.5 backdrop-blur-md"
        >
          <span className="text-[11px] font-bold uppercase tracking-[0.2em] px-6 lg:px-0 text-slate-700">
            Meet our team of experts
          </span>
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.08 }}
          className="font-display text-3xl sm:text-4xl md:text-5xl font-bold px-6 lg:px-0 tracking-tight text-slate-950 "
        >
          Our{" "}
          <span className="italic font-serif font-normal text-[#5dc9f0]">
            Leadership Team
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="mt-5 max-w-2xl text-base font-normal leading-relaxed text-center px-6 lg:px-0 text-slate-600 sm:text-lg"
        >
          Our core principle is to invest in people, communities, and the
          success of our clients
        </motion.p>
        

        {/* Staggered Circular Gallery */}
        <div className="grid grid-cols-1 sm:grid-cols-2 mt-10 pt-20 xl:grid-cols-4 gap-10 md:gap-8 lg:gap-16 items-start justify-items-center">
          {TEAM_MEMBERS.map((member, idx) => (
            <TeamMemberCircle key={member.name} member={member} index={idx} />
          ))}
        </div>
         <h2 className="  text-center  w-full text-2xl md:text-3xl font-semibold tracking-tight text-[#000036] mb-6 pt-16 md:pb-10 mt-10">
          Our Core Team
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 mt-10 pt-5 xl:grid-cols-5 gap-10 md:gap-8 lg:gap-16  items-start justify-items-center">
          {CORE_MEMBERS.map((member, idx) => (
            <TeamMemberCircle key={member.name} member={member} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
